<template>
  <div>
    <Modal modalId="generatePdf" v-if="selected.length > 0"
      ><component
        :is="'generate-pdf-template'"
        :data="selected[0]"
        ref="pdfGenerator"
      ></component>
    </Modal>
    <v-row>
      <dropdownlist
        id="dropdownList"
        :data-items="getClient"
        :text-field="'companyName'"
        :data-item-key="'companyRegistrationId'"
        :filterable="true"
        @filterchange="filterChange"
        @change="onChange"
        :default-item="defaultItem"
        style="padding-bottom: 15px; padding-right: 10px;"
      ></dropdownlist>
      <button
        v-if="showResetButton"
        class="btn btn-primary"
        @click="resetSearch"
        style="margin-bottom:15px"
      >
        Reset
      </button>
    </v-row>
    <v-row>
      <button
        class="btn btn-primary"
        @click="printGrid('pdf')"
        :disabled="selected.length === 0"
      >
        View worklog
      </button>
      <button
        class="btn btn-primary ml-2"
        @click="deleteWorklog"
        :disabled="selected.length === 0"
      >
        Delete worklog
      </button>
      <button
        class="btn btn-primary ml-2 mr-2"
        @click="changeStatus"
        :disabled="selected.length === 0"
      >
        Change status
      </button>
      <button
        class="btn btn-primary ml-2"
        @click="printGrid('excel')"
        :disabled="getWorklogs.length === 0"
      >
        Export Excel
      </button>
      <button
        class="btn btn-primary ml-2"
        @click="invoice"
        :disabled="selected.length === 0 || selected[0].isInvoiced === true"
      >
        Fakturisi
      </button>
    </v-row>
    <div class="row pl-3 pr-3 mt-3">
      <div id="vueapp" class="vue-app" v-if="getWorklogs.length > 0">
        <v-data-table
          v-model="selected"
          :headers="columns"
          :items="getWorklogs"
          :single-select="true"
          :sort-by="['dateTicketWasOpened', 'dateTicketWasClosed']"
          :sort-desc="[true, true]"
          item-key="worklogNumber"
          show-select
          class="elevation-1"
        >
          <template v-slot:item.dateTicketWasOpened="{ item }">
            <span>{{ new Date(item.dateTicketWasOpened) | moment }}</span>
          </template>
          <template v-slot:item.dateTicketWasClosed="{ item }">
            <span>{{ new Date(item.dateTicketWasClosed) | moment }}</span>
          </template>
        </v-data-table>
      </div>
      <div v-else>
        <h2>Trenutno nemamo kreiranih naloga. Kreiraj radni nalog !</h2>
      </div>
    </div>
  </div>
</template>
<script>
import $ from "jquery";
import GeneratePdfTemplate from "@/components/Worklog/GeneratePdfTemplate.vue";
import Modal from "@/components/Common/Modal";
import moment from "moment";
import { json2excel } from "js2excel";
import { DropDownList } from "@progress/kendo-vue-dropdowns";
import { filterBy } from "@progress/kendo-data-query";
const textField = "companyName";
const keyField = "companyRegistrationId";
const defaultItem = { [textField]: "Select customer...", [keyField]: null };
const emptyItem = { [textField]: "loading ..." };

export default {
  components: {
    Modal,
    "generate-pdf-template": GeneratePdfTemplate,
    dropdownlist: DropDownList
  },
  created() {
    this.$store.dispatch("getAllWorklogs", { closedTickets: true });
  },

  data() {
    return {
      selected: [],
      defaultItem: defaultItem,
      selectedID: false,
      target: "#closedTarget",
      exportSettings: {
        fileName: "ExcelExport.xlsx"
        // proxyURL: "https://demos.telerik.com/kendo-ui/service/export"
      },
      columns: [
        {
          value: "worklogNumber", // create a column bound to the "name" field
          text: "Sifra radnog naloga"
        },
        {
          value: "customer",
          text: "Klijent"
        },
        {
          value: "typeOfProblem",
          text: "Opis problema"
        },
        {
          value: "problemDescription",
          text: "Opis problema"
        },
        {
          value: "dateTicketWasOpened",
          text: "Datum otvaranja naloga"
        },

        {
          value: "contactPerson",
          text: "Kontakt osoba"
        },
        {
          value: "phoneNumber",
          text: "Broj telefona"
        },

        {
          value: "dateTicketWasClosed",
          text: "Datum zatvaranja tiketa"
        },
        {
          value: "status",
          text: "Status"
        }
      ],
      showResetButton: false,
      temp: []
    };
  },
  methods: {
    onChange(event) {
      /*eslint-disable*/
      const value = event.value;
      console.log(value);
      if (value && value[textField] === emptyItem[textField]) {
        return;
      }
      this.selectCustomer = value;
      this.phoneNumber = value.phoneNumber;
      this.temp = this.temp.length > 0 ? this.temp : this.getWorklogs;
      this.$store.dispatch("filterClosedWorklogs", value.companyName);
      this.$store.commit("setClients", this.getSafeClients);
      this.showResetButton = true;
    },
    filterChange(event) {
      var array = this.getClient.splice();
      array = this.filterData(event.filter);
      this.$store.commit("setClients", array);
    },
    filterData(filter) {
      if (filter.value.length <= 1)
        this.$store.commit("setClients", this.getSafeClients);
      const data = this.getClient.slice();
      return filterBy(data, filter);
    },
    resetSearch() {
      this.showResetButton = false;
      const data = this.getClient.slice();
      this.$store.commit("setClosedWorklogs", this.temp);
      return filterBy(data, {
        field: "companyName",
        ignoreCase: true,
        operator: "contains",
        value: ""
      });
    },
    deleteWorklog() {
      this.$store.dispatch("deleteWorklog", this.selected[0].worklogNumber);
    },
    changeStatus() {
      this.$store.dispatch("changeWorklogStatus", this.selected[0]);
    },
    printGrid(format) {
      if (format === "pdf") {
        $("#generatePdf").modal("toggle");
      } else {
        const data = this.getWorklogs;
        data.forEach(item => {
          var sumHours = 0;
          item.dateTicketWasOpened = this.$options.filters.moment(
            item.dateTicketWasOpened
          );
          item.dateTicketWasClosed = this.$options.filters.moment(
            item.dateTicketWasClosed
          );
          if (item.tasks && item.tasks.length > 0) {
            item.tasks.forEach(i => {
              sumHours += parseInt(i.workTimeSpent, 10);
            });
          }
          if (item.isInvoiced) {
            item.fakturisano = "Fakturisano";
          } else {
            item.fakturisano = "nije fakturisano";
          }

          item.spentHours = sumHours;
          delete item.isInvoiced;
          delete item.taskInProgress;
        });
        try {
          json2excel({
            data,
            name: "Closed-worklogs",
            formatDate: "yyyy/mm/dd"
          });
        } catch (error) {
          // console.log(error);
        }
      }
    },
    invoice() {
      this.$store.dispatch("invoiceWorklog", this.selected[0]);
    }
  },
  computed: {
    getWorklogs() {
      return this.$store.getters.getClosedWorklogs;
    },
    getClient() {
      return this.$store.getters.getClients;
    },
    getSafeClients() {
      return this.$store.getters.getSafeClients;
    }
  },
  filters: {
    moment: function(date) {
      return moment(date).format("DD-MM-YYYY HH:MM");
    }
  }
};
</script>
<style></style>
